/**
 * Shared persistence helpers for the Explore Sidebar (V1 & V2).
 */

const STORAGE_KEY = 'exploreSidebar';

type ExploreSidebarSettings = {
  version: number;
  isExpanded: boolean;
};

function getUserSettings(username: string): Record<string, any> {
  return JSON.parse(window.localStorage.getItem(username) || '{}');
}

export function writeExploreSidebar(username: string, version: number, isExpanded: boolean): void {
  window.localStorage.setItem(
    username,
    JSON.stringify({
      ...getUserSettings(username),
      [STORAGE_KEY]: { version, isExpanded }
    })
  );
}

/**
 * Returns the initial `isExpanded` value for the sidebar, applying
 * version migration. If no settings exist or the stored version is older
 * than `currentVersion`, the stored value is reset to
 * `{ version: currentVersion, isExpanded: true }` as a side effect.
 */
export function readOrInitExploreSidebarIsExpanded(
  username: string,
  currentVersion: number
): boolean {
  const userSettings = getUserSettings(username);
  const stored: ExploreSidebarSettings | undefined = userSettings?.[STORAGE_KEY];

  let isExpanded = true;
  let isOldVersion = false;

  if (stored) {
    isOldVersion = stored.version < currentVersion;
    isExpanded = isOldVersion ? true : stored.isExpanded;
  }

  if (!stored || isOldVersion) {
    writeExploreSidebar(username, currentVersion, true);
  }

  return isExpanded;
}
